(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda-day-part
    module.controller('AgendaDayController', ['AgendaOverviewService', AgendaDayControllerFn]);

    function AgendaDayControllerFn(AgendaOverviewService) {
        var vm = this;

        vm.collapsed = false;

        activate();

        // collapse
        vm.collapse = function () {
            vm.collapsed = !vm.collapsed;
        };

        // go to agenda-per-day
        vm.agendaPerDay = function () {
            AgendaOverviewService.showAgendaPerDay(vm.date);
        };
              

        // activation work
        function activate() {
        } // activate

    }

})();